import { useEffect, useState } from "react";

// Keep these in sync with the CSS media queries (768px / 992px).
const MOBILE_QUERY = "(max-width: 768px)";
const TABLET_QUERY = "(max-width: 992px)";

const read = () => {
  if (typeof window === "undefined") return "desktop";
  if (window.matchMedia(MOBILE_QUERY).matches) return "mobile";
  if (window.matchMedia(TABLET_QUERY).matches) return "tablet";
  return "desktop";
};

/** Returns "mobile" (<=768), "tablet" (769-992) or "desktop" (>992). */
const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState(read);

  useEffect(() => {
    const queries = [
      window.matchMedia(MOBILE_QUERY),
      window.matchMedia(TABLET_QUERY),
    ];
    const update = () => setBreakpoint(read());
    queries.forEach((q) => q.addEventListener("change", update));
    update();
    return () =>
      queries.forEach((q) => q.removeEventListener("change", update));
  }, []);

  return breakpoint;
};

export default useBreakpoint;
